import { createContext } from 'react';
import { CommonContexts } from '../types';

export const UuiContext = createContext({} as CommonContexts<any, any>);
